"use client";

import { useEffect } from "react";
import toast from "react-hot-toast";
import { trpc } from "~/utils/trpc.client";

export const VersionChecker = () => {
  const clientBuildTime =
    (import.meta.env.VITE_BUILD_TIME as string | undefined) ?? "";

  // Version-drift only matters for a real deployed build. In dev/local the
  // client is served fresh with no baked build time, so `clientBuildTime` is
  // "". Comparing that against the server's BUILD_TIME would nag permanently
  // (e.g. a stale cached bundle or a local `pnpm build` that baked a value the
  // running server never had). Only run the check when the client actually
  // carries a build time.
  const enabled = clientBuildTime !== "";

  const getBuildTimeQuery = trpc.auth.getBuildTime.useQuery(
    { clientBuildTime },
    { refetchInterval: 60000, enabled },
  );

  // every time there's a new build time, check if it's different from the current build time
  useEffect(() => {
    if (
      enabled &&
      getBuildTimeQuery.data != null &&
      getBuildTimeQuery.data !== clientBuildTime
    ) {
      toast(
        "There is a new version of the app available. Refresh your page to update.",
        {
          duration: Infinity,
        },
      );
    }
  }, [enabled, clientBuildTime, getBuildTimeQuery.data]);

  // On the first mount, log the build time
  useEffect(() => {
    console.log("Build time:", clientBuildTime || "(dev)");
  }, [clientBuildTime]);

  return null;
};
